import { createRouter, createWebHashHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta:{
      title:"UNIV太空",
      content: {

				keywords: "univspace,univ,太空,魔方太空,设计,品牌,产品,魔法",

				description: 'UNIV太空专注基于最新科技，创造魔法般的产品体验和视觉方案。为企业提供设计方案以及设计咨询服务。'

			}
    }
  },
  {
    path: '/about',
    name: 'about',
    meta:{
      title:"UNIV太空-关于",
      content: {

				keywords: "univspace,univ,太空,魔方太空,设计,品牌,产品,魔法",

				description: 'UNIV太空专注基于最新科技，创造魔法般的产品体验和视觉方案。为企业提供设计方案以及设计咨询服务。'

			}
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/ConceptView',
    name: 'ConceptView',
    meta:{
      title:"UNIV太空-概念",
      content: {

				keywords: "univspace,univ,太空,魔方太空,项目，展品",

				description: 'UNIV太空专注基于最新科技，创造魔法般的产品体验和视觉方案。为企业提供设计方案以及设计咨询服务。'

			}
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/ConceptView.vue')
  },
  {
    path: '/projectdetails',
    name: 'projectdetails',
    meta:{
      title:"UNIV太空-项目详情",
      content: {

				keywords: "univspace,univ,太空,魔方太空,项目，展品",

				description: 'UNIV太空专注基于最新科技，创造魔法般的产品体验和视觉方案。为企业提供设计方案以及设计咨询服务。'

			}
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/ProjectDetails.vue')
  },
  {
    path: '/mytest',
    name: 'mytest',
    meta:{
      title:"UNIV太空-mytest",
      content: {

				keywords: "univspace,univ,太空,魔方太空,项目，展品",

				description: 'UNIV太空专注基于最新科技，创造魔法般的产品体验和视觉方案。为企业提供设计方案以及设计咨询服务。'

			}
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/MyTest.vue')
  },
  {
    path: '/law',
    name: 'law',
    meta:{
      title:"UNIV太空-法律声明",
      content: {

				keywords: "univspace,univ,太空,魔方太空,法律",

				description: 'UNIV太空专注基于最新科技，创造魔法般的产品体验和视觉方案。为企业提供设计方案以及设计咨询服务。'

			}
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/LawStatement.vue')
  },
  {
    path: '/FluidDrawing',
    name: 'FluidDrawing',
    meta:{
      title:"UNIV太空-流体画",
      content: {

				keywords: "univspace,univ,太空,魔方太空,流体画",

				description: 'UNIV太空专注基于最新科技，创造魔法般的产品体验和视觉方案。为企业提供设计方案以及设计咨询服务。'

			}
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/FluidDrawing.vue')
  },
  {
    path: '/3dmap',
    name: '3dmap',
    meta:{
      title:"UNIV太空-3D导览",
      content: {

				keywords: "univspace,univ,太空,魔方太空,流体画",

				description: 'UNIV太空专注基于最新科技，创造魔法般的产品体验和视觉方案。为企业提供设计方案以及设计咨询服务。'

			}
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/3dmap.vue')
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})
router.beforeEach((to) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  if (to.meta.content) {

		let head = document.getElementsByTagName('head');

		let meta = document.createElement('meta');

		document.querySelector('meta[name="keywords"]').setAttribute('content', to.meta.content.keywords)

		document.querySelector('meta[name="description"]').setAttribute('content', to.meta.content.description)

		meta.content = to.meta.content;

		head[0].appendChild(meta)

	}
})

export default router
